/*
 * decription:设置后台管理 模块可见性主体高度
 * created:chenhao
 * created time: 2017-12-15 11:12:37
 */
"use strict";
angular.module("moduleVisibilityHeightModule", [])
    .directive("trsManageHeight", ["$window", "$timeout", function($window, $timeout) {
        return {
            restrict: "A",
            link: function(scope, iElem, iAttrs) {
                function setMainHeight() {
                    $timeout(function() {
                        iElem.height($(window).height() - ($(".view_head").outerHeight(true) + $(".tabBtn").outerHeight(true)));
                    });
                }
                setMainHeight();
                $("body,.view_head,.tabBtn").resize(function() {
                    setMainHeight();
                });
            }
        };
    }]);